module.exports = __webpack_public_path__ + "img/soft.ceac70d9.png";